import { AnyAction } from "redux";
import { GET_MANAGEMENT_LIST_FAILURE, GET_MANAGEMENT_LIST_REQUEST, GET_MANAGEMENT_LIST_SUCCESS } from "../constants/userManagement.constants";

const initialState = {
    loading: false,
    data: [],
    errorMsg: '',
    count: 0
};

export const managemnetReducer = (state = initialState, action: AnyAction) => {

    switch (action.type) {
        case GET_MANAGEMENT_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_MANAGEMENT_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.data || [],
                count: action.payload.count || 0,
                errorMsg: '',
            };
        case GET_MANAGEMENT_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };

        default:
            return state
    }
}